import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApplicationResponse,  StateTrackedData } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import { MDMEventModelRef, MDMEventStore } from "../domain/mdm-events.model";

export const createMDMEvent = createAsyncThunk<void, any>(
  "mdmEvent/createMDMEvent",
  async (payload: any) => {
    const url = `${AppConstants.api}/eventMDM`;
    const response = await api.post<ApplicationResponse<any>>(
      url,
      payload
    );
    return response.data.data || [];
  }
);
export const updateMDMEvent = createAsyncThunk<void, any>(
  "mdmEvent/updatemdmEvent",
  async (payload: any) => {
    const url = `${AppConstants.api}/eventMDM`;
    const response = await api.put<ApplicationResponse<any>>(
      url,
      payload
    );
    return response.data.data || [];
  }
);
export const deleteMDMEvent = createAsyncThunk(
  "mdmEvent/deletemdmEvent",
  async (id: string) => {
    try {
      const response = await api.delete<ApplicationResponse<any[]>>(
        `${AppConstants.api}/eventMDM?id=${id}`
      );
      return response.data.data || [];
    } catch (err) {
      return [];
    }
  }
);
export const fetchMDMEventList = createAsyncThunk<any[], void>(
    "mdmEvent/fetchMDMEventList",
    async () => {
          const response = await api.get<ApplicationResponse<MDMEventModelRef[]>>(`${AppConstants.api}/eventMDM`)
        return response.data.data || []
    }
);

const mdmEventSlice = createSlice({
  name: "mdmEvent",
  initialState: {
    minimal: { status: "loading", error: null, data: [] },
  } as MDMEventStore,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMDMEventList.pending, (state, action) => {
        state.minimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchMDMEventList.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchMDMEventList.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      });
  },
});

export default mdmEventSlice.reducer;


